"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = closeFullscreen;

function closeFullscreen() {
  var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.documentElement;
  return new Promise(function (resolve, reject) {
    if (element.exitFullscreen) {
      resolve(element.exitFullscreen());
    } else if (element.webkitExitFullscreen) {
      resolve(element.webkitExitFullscreen()); // Safari
    } else if (element.msExitFullscreen) {
      resolve(element.msExitFullscreen()); // IE11
    } else {
      reject(new Error("Unable to closeFullScreen."));
    }
  });
}